// extracted by mini-css-extract-plugin
export default {"tripleSpinnerContainer":"loader_tripleSpinnerContainer__Y6iYd","tripleSpinner":"loader_tripleSpinner__moA7v","spin":"loader_spin__wLqnC"};